module.exports = __webpack_public_path__ + "static/media/graph.1106eafc.svg";